import React from 'react';

const UserMentionComponent = (props: any) => {
    return <span style={{ color: '#008ac9', textDecoration: 'none' }}>{props.children}</span>;
};

export default UserMentionComponent;
